import React from 'react';

import { SubTitle, Card, GenericP } from '../../../../common/Styles';
import { LandingSpriteIcon } from '../../../Styles';
import { ImgWrap, CardWrap } from './benefitTyleStyles';

const BenefitTile = ({ isMobile, data }) => {
	const { heading, description, icon, iconUrl } = data;
	return (
		<CardWrap boxPadding='30px' boxMargin='0 0 16px 0'>
			<SubTitle
				fSize={`${isMobile ? '22px' : '26px'}`}
				color='#000'
				bottom_M='16'>
				{heading}
			</SubTitle>
			<GenericP fsize={isMobile ? '14px' : '16px'} bottom_M='30'>
				{description}
			</GenericP>
			<ImgWrap>
				{iconUrl ?
					<img crossOrigin='anonymous' loading='lazy' src={iconUrl} width='80' height='80' /> :
					<LandingSpriteIcon icon={icon} />}
			</ImgWrap>
		</CardWrap>
	);
};

export default BenefitTile;
